import { toast } from "sonner";
import { env } from "@/env";

export async function executeTaskNow(taskId: number, accessToken: string): Promise<string | null> {
	try {
		const response = await fetch(`${env.VITE_API_BASE_URL}/api/v1/tasks/${taskId}/execute`, {
			method: "POST",
			headers: { Authorization: `Bearer ${accessToken}` },
		});
		if (!response.ok) {
			toast.error("Failed to start task");
			return null;
		}

		const reader = response.body?.getReader();
		const decoder = new TextDecoder();
		if (reader) {
			let buffer = "";
			while (true) {
				const { value, done } = await reader.read();
				if (done) break;
				buffer += decoder.decode(value, { stream: true });
				const match = buffer.match(/"run_id"\s*:\s*(\d+)/);
				if (match) {
					void reader.cancel();
					return match[1];
				}
			}
		}
	} catch {
		toast.error("Failed to start task");
	}

	return null;
}
